import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {ResultadoModel} from '../models/resultado.model';
import {Observable} from 'rxjs';

@Injectable()
export class ResultadoServices {

  public obsSaveResult:Observable<any>;

  constructor(private  apollo:Apollo, private ss:SocketServices) {
    this.obsSaveResult = this.ss.registrarEvento("updRespuesta");
  }

  saveResultado(resultado:ResultadoModel){
    // this.ss.enviarEvento('saveRespuesta',{id:resultado._id,data:JSON.stringify(resultado)});
  }
}
